import { render, staticRenderFns } from "./PatSearch.vue?vue&type=template&id=55543776&scoped=true"
import script from "./PatSearch.vue?vue&type=script&lang=js"
export * from "./PatSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55543776",
  null
  
)

export default component.exports